import React from 'react';
import TagPill from '../ui/TagPill';

interface FilterBarProps {
    filters: Record<string, string>;
    onRemoveFilter: (key: string) => void;
    onClearAll: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ filters, onRemoveFilter, onClearAll }) => {
    const entries = Object.entries(filters);

    if (entries.length === 0) {
        return (
            <div className="h-[42px] bg-surface border border-line rounded-full px-4 flex items-center text-sm text-ink-muted">
                No filters applied
            </div>
        );
    }

    return (
        <div className="min-h-[42px] bg-surface border border-line rounded-full px-4 py-2 flex items-center gap-2 flex-wrap">
            <span className="text-sm text-ink-muted mr-1">Filters:</span>
            {entries.map(([key, value]) => (
                <FilterChip key={key} label={key} value={value} onRemove={() => onRemoveFilter(key)} />
            ))}
            {entries.length >= 2 && <ClearAllButton onClick={onClearAll} />}
        </div>
    );
};

function FilterChip({
    label,
    value,
    onRemove,
}: {
    label: string;
    value: string;
    onRemove: () => void;
}) {
    return (
        <TagPill onRemove={onRemove} removeLabel={`Remove ${label} filter`}>
            <span className="capitalize">{label}:</span> {value}
        </TagPill>
    );
}

function ClearAllButton({ onClick }: { onClick: () => void }) {
    return (
        <button
            onClick={onClick}
            className="text-sm text-ink-muted hover:text-ink ml-2 underline"
        >
            Clear all
        </button>
    );
}

export default FilterBar;
